export default function (def, schema) {
  def.type = 'j-html'
}
